import React from "react";
import { Box } from "rebass";
import { AnswerItem } from "./styled";

const AnswerBox = ({
  answerText,
  onChange,
  ...rest
}) => {
  return (
    <Box {...rest}>
      <AnswerItem
        onChange={onChange}
        value={answerText}
        placeholder="Insert text here."
      />
    </Box>
  );
};

export default AnswerBox;
